import Vue from 'vue';

export const dialogState = Vue.observable({ queue: [] });

export const escapeHtml = value => String(value).replace(/[&<>"']/g, character => `&#${character.charCodeAt(0)};`);

const open = (type, options) => new Promise((resolve, reject) => {
    if (options.key && dialogState.queue.some(entry => entry.options.key === options.key)) {
        resolve(false);
        return;
    }

    dialogState.queue.push({
        type,
        options,
        resolve,
        reject
    });
});

export const dialog = {
    confirm (options) {
        return open('confirm', options);
    },

    alert (options) {
        return open('alert', options);
    }
};

const DialogPlugin = {
    install (VueInstance) {
        VueInstance.prototype.$dialog = dialog;
    }
};

export default DialogPlugin;
